export const getDiscount = (amount: number, rate: number) => {
  return amount * rate / 100
}